"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePlugin = exports.ParentSetState = exports.Parent = void 0;
const react_1 = __importDefault(require("react"));
class Parent extends react_1.default.Component {
}
exports.Parent = Parent;
function ParentSetState(parent, storageKey, stateFunction) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise(resolve => {
            parent.setState(p => {
                const newStorageState = Object.assign(Object.assign({}, p.context[storageKey]), stateFunction(p.context[storageKey]));
                return {
                    context: Object.assign(Object.assign({}, p.context), { [storageKey]: newStorageState })
                };
            }, () => resolve());
        });
    });
}
exports.ParentSetState = ParentSetState;
class BasePlugin {
    constructor(parent, parentStorageKey) {
        this.parent = parent;
        this.parentStorageKey = parentStorageKey;
    }
    parentSetState(stateFunction) {
        this.parent.setState(p => {
            const newStorageState = Object.assign(Object.assign({}, p.context[this.parentStorageKey]), stateFunction(p.context[this.parentStorageKey]));
            return {
                context: Object.assign(Object.assign({}, p.context), { [this.parentStorageKey]: newStorageState })
            };
        });
    }
}
exports.BasePlugin = BasePlugin;
//# sourceMappingURL=BasePlugin.js.map